<div class="flex-container" *ngIf="(cognitoAuthService.loggedInAuth0$ | async)">
  <div class="main-content-container">
    <div style="text-align:center">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>